/* Casemira Custom Filters v8 — chips pilotées par l'URL, un param par chip */
(function() {
  /* CASEMIRA (18/08/2026) : chaque chip porte désormais SON propre paramètre de filtre
     (`data-cf-param`), au lieu d'être toutes des valeurs de `filter.p.tag` distinguées par
     un préfixe « style: » / « couleur: ». Le « groupe » d'une chip est donc simplement son
     paramètre : filter.p.m.custom.style_motif, ...couleur_filtre, etc.
     Seule « Fait main » reste sur filter.p.tag (le filtre Balises n'est plus affiché mais
     reste actif dans S&D pour les anciennes URLs). Pour ce cas on ne touche QUE la valeur
     cliquée : les autres valeurs de tag éventuellement présentes dans l'URL (vieux liens)
     doivent survivre, sans quoi un clic sur « Fait main » les effacerait silencieusement.
     Comportement conservé à l'identique pour le reste : à l'intérieur d'un même groupe la
     chip se comporte en radio (la nouvelle valeur remplace la précédente). */
  var LEGACY_TAG_PARAM = 'filter.p.tag';

  function handleChipClick(e) {
    var chip = e.target.closest('.cf-chip[data-cf-type="tag"]');
    if (!chip) return;
    e.preventDefault();

    var value = chip.getAttribute('data-cf-value');
    var param = chip.getAttribute('data-cf-param');
    if (!value || !param) return;

    var params = new URLSearchParams(window.location.search);
    var currentValues = params.getAll(param);
    var isActive = currentValues.indexOf(value) !== -1;
    var isLegacyTag = param === LEGACY_TAG_PARAM;

    var newParams = new URLSearchParams();

    /* On garde tout ce qui ne concerne pas le paramètre cliqué (tri, page, prix, taille…) */
    params.forEach(function(v, k) {
      if (k !== param) {
        newParams.append(k, v);
      }
    });

    /* Tag hérité : on conserve les autres valeurs du même paramètre.
       Filtre metafield : radio dans le groupe, les autres valeurs sont remplacées. */
    if (isLegacyTag) {
      currentValues.forEach(function(v) {
        if (v !== value) newParams.append(param, v);
      });
    }

    /* Ajout de la valeur cliquée si elle n'était pas déjà active (re-clic = désactivation) */
    if (!isActive) {
      newParams.append(param, value);
    }

    /* Navigate to new URL — facets.js will pick up the change */
    var newUrl = window.location.pathname + '?' + newParams.toString();

    /* Use facet-remove style navigation if available, otherwise direct */
    var form = document.querySelector('form[is="facet-form"]');
    if (form && typeof form.onSubmit === 'function') {
      window.location.href = newUrl;
    } else {
      /* Trigger via history + fetch like facets.js does */
      history.pushState(null, '', newUrl);
      
      /* Fetch the new page content and swap */
      fetch(newUrl, { headers: { 'Accept': 'text/html' } })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          /* Swap product grid */
          var newGrid = doc.getElementById('ProductGridContainer');
          var oldGrid = document.getElementById('ProductGridContainer');
          if (newGrid && oldGrid) oldGrid.innerHTML = newGrid.innerHTML;

          /* Swap filters sidebar */
          var newFilters = doc.getElementById('FacetFiltersContainer');
          var oldFilters = document.getElementById('FacetFiltersContainer');
          if (newFilters && oldFilters) oldFilters.innerHTML = newFilters.innerHTML;

          /* Swap active filters */
          var newActive = doc.getElementById('FacetFiltersActive');
          var oldActive = document.getElementById('FacetFiltersActive');
          if (newActive && oldActive) oldActive.innerHTML = newActive.innerHTML;

          /* Swap product count */
          var newCount = doc.getElementById('ProductCount');
          var oldCount = document.getElementById('ProductCount');
          if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;

          /* Update chip states */
          updateAllChipStates();
        });
    }
  }

  function updateAllChipStates() {
    var params = new URLSearchParams(window.location.search);

    /* CASEMIRA: l'état actif se lit maintenant dans le paramètre propre à chaque chip. */
    document.querySelectorAll('.cf-chip[data-cf-type="tag"]').forEach(function(chip) {
      var value = chip.getAttribute('data-cf-value');
      var param = chip.getAttribute('data-cf-param');
      var active = !!param && params.getAll(param).indexOf(value) !== -1;
      chip.classList.toggle('cf-chip--active', active);
    });
  }

  document.addEventListener('click', handleChipClick);

  function setupObserver() {
    ['ProductGridContainer', 'FacetFiltersContainer'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        new MutationObserver(function() {
          setTimeout(updateAllChipStates, 150);
        }).observe(el, { childList: true, subtree: true });
      }
    });
  }

  window.addEventListener('popstate', function() {
    setTimeout(updateAllChipStates, 100);
  });

  var origPushState = history.pushState;
  var origReplaceState = history.replaceState;
  history.pushState = function() {
    origPushState.apply(this, arguments);
    setTimeout(updateAllChipStates, 150);
  };
  history.replaceState = function() {
    origReplaceState.apply(this, arguments);
    setTimeout(updateAllChipStates, 150);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupObserver();
      updateAllChipStates();
    });
  } else {
    setupObserver();
    updateAllChipStates();
  }
})();

/* CASEMIRA: sidebar de filtres « sticky bidirectionnelle » (ordinateur ≥ 1280 px).
   Problème : en sticky-top simple, une colonne plus haute que l'écran garde son bas
   (Dimensions, Prix) hors de portée ; en sticky-bas simple (v4), c'est son haut qui devient
   inatteignable, et toute variation de hauteur pendant qu'elle est figée décalait la
   colonne — le bloc qu'on venait de cliquer sautait hors de l'écran.

   Principe : on garde `position: sticky` et on ne pilote que son `top`. À chaque pas de
   scroll, `top` varie de l'inverse du déplacement, borné à [minTop, maxTop] :
     maxTop = offset haut du thème, lu tel qu'appliqué (tous états de header confondus),
              relevé au bas de la barre d'outils sticky quand celle-ci descend plus bas
     minTop = hauteur du viewport − hauteur de la colonne − marge basse
   Tant que `top` est entre les deux bornes, la colonne reste immobile dans le DOCUMENT :
   elle défile donc avec la page, dans les deux sens, sans le moindre saut (la position est
   continue par construction, puisque `top` compense exactement le scroll). Quand `top` bute
   sur maxTop la colonne se fige par le haut, quand il bute sur minTop elle se fige par le
   bas. Si la colonne est plus courte que l'écran, minTop repasse au-dessus de maxTop et on
   retrouve le sticky-top d'origine.

   Changement de hauteur (accordéon, « Afficher plus », re-rendu AJAX) : on ne recalcule PAS
   `top`, on se contente de le re-borner. Il garde donc sa valeur tant qu'il reste dans les
   bornes → la colonne ne bouge pas d'un pixel, le contenu se déplie vers le bas et devient
   accessible en continuant à descendre. C'est l'ancrage voulu.

   Dégradation : si @property n'est pas supporté (offsets illisibles en pixels), aucun `top`
   n'est posé en ligne et le min() CSS de custom-filters.css reprend la main. */
(function () {
  var BREAKPOINT = '(min-width: 1280px)';
  var CONTAINER_ID = 'FacetFiltersContainer';
  var TOOLBAR_GAP = 8; /* respiration entre le bas de la barre d'outils et la colonne */

  var container = null;
  var wrapper = null;

  var active = false;
  var appliedTop = null; /* dernière valeur de `top` posée en ligne, en px */

  /* Métriques mises en cache : elles ne sont relues que lorsqu'un événement peut les avoir
     changées (re-rendu, accordéon, resize, état du header). Un simple scroll n'a alors plus
     besoin d'aucune lecture de layout — juste une soustraction et une borne. */
  var metricsDirty = true;
  var maxTop = NaN;
  var bottomGap = NaN;
  var height = 0;

  var lastScrollY = 0;
  var ticking = false;

  /* Ne renvoie une valeur que si le navigateur a bien résolu la longueur en pixels. */
  function pxValue(styles, name) {
    var raw = styles.getPropertyValue(name).trim();
    if (raw.slice(-2) !== 'px') return NaN;

    var value = parseFloat(raw);
    return isFinite(value) ? value : NaN;
  }

  /* Le wrapper .sticky-element est DÉTRUIT à chaque re-rendu AJAX des filtres
     (renderFacetFiltersContainer remplace le innerHTML du container). Seul le container
     survit : on re-résout donc le wrapper dès qu'il n'est plus rattaché au document. */
  function resolveWrapper() {
    if (wrapper && wrapper.isConnected) return true;

    wrapper = container ? container.querySelector('.sticky-element') : null;
    metricsDirty = true;
    return !!wrapper;
  }

  /* CASEMIRA: la barre d'outils « Filtrer | N produits » est elle aussi sticky, opaque
     (fond blanc) et au-dessus de la colonne (z-9 contre z-8). Si l'offset haut de la colonne
     est plus petit que le bas de cette barre, le premier accordéon (« Style ») disparaît
     dessous. C'est le cas partout : en collection header épinglé la barre occupe 180→264 px
     alors que --cm-facets-top vaut 214 px ; sur la page recherche, qui n'a PAS la surcharge
     d'offset de main-collection-product-grid.liquid, elle se colle à 0→84 px (sous le topbar
     sticky) contre 72 px pour la colonne. On mesure donc le bas réel de la barre à chaque
     relecture de métriques — les changements d'état du header invalident déjà le cache — et
     on l'utilise comme plancher de l'offset haut. Aucune constante à re-coder par gabarit. */
  function stickyToolbarBottom() {
    var toolbar = document.querySelector('.collection__toolbar');
    var toolbarSticky = toolbar ? toolbar.closest('.sticky-element') : null;
    if (!toolbarSticky) return -Infinity;

    var top = pxValue(getComputedStyle(toolbarSticky), 'top');
    if (!isFinite(top)) return -Infinity;

    return top + toolbarSticky.getBoundingClientRect().height + TOOLBAR_GAP;
  }

  function readMetrics() {
    var styles = getComputedStyle(wrapper);
    var measuredHeight = Math.round(wrapper.getBoundingClientRect().height);

    maxTop = pxValue(styles, '--cm-facets-top');
    if (isFinite(maxTop)) maxTop = Math.max(maxTop, stickyToolbarBottom());
    bottomGap = pxValue(styles, '--cm-facets-bottom-gap');

    if (measuredHeight > 0 && measuredHeight !== height) {
      height = measuredHeight;
      /* Alimente le filet de sécurité CSS, utilisé quand le pilotage JS est inactif. */
      container.style.setProperty('--cm-facets-height', height + 'px');
    }

    metricsDirty = false;
  }

  function refresh(delta) {
    if (!container || !resolveWrapper()) return;

    if (metricsDirty) readMetrics();
    if (!active || height <= 0 || !isFinite(maxTop) || !isFinite(bottomGap)) return;

    var minTop = window.innerHeight - height - bottomGap;
    var next;

    if (minTop >= maxTop) {
      /* Colonne plus courte que l'écran : sticky-top classique. */
      next = maxTop;
    } else {
      var base = appliedTop === null ? maxTop : appliedTop;
      /* CASEMIRA: maxTop varie avec l'état du header (barre d'outils épinglée ou remontée
         hors écran). S'il DIMINUE alors que la colonne est déjà plus bas, un simple
         Math.min la ferait sauter de 200 px d'un coup. Le plafond ne s'applique donc qu'en
         montée : au-delà de maxTop la colonne ne peut que redescendre, au fil du scroll,
         jusqu'à retrouver la plage normale. */
      var ceiling = base > maxTop ? base : maxTop;
      next = Math.min(ceiling, Math.max(minTop, base - delta));
    }

    next = Math.round(next);

    /* `style.top` vide = wrapper recréé par un re-rendu : il faut réappliquer même si la
       valeur calculée n'a pas changé. */
    if (next !== appliedTop || wrapper.style.top === '') {
      appliedTop = next;
      wrapper.style.top = next + 'px';
    }
  }

  /* Point d'entrée unique, une exécution par frame au maximum. Le delta se déduit du scroll :
     un simple recalcul (accordéon, re-rendu, header épinglé) passe donc avec un delta nul et
     ne déplace pas la colonne. */
  function schedule() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function () {
      ticking = false;

      var scrollY = window.scrollY;
      var delta = scrollY - lastScrollY;
      lastScrollY = scrollY;

      refresh(delta);
    });
  }

  function invalidate() {
    metricsDirty = true;
    schedule();
  }

  function setActive(value) {
    if (value === active) return;
    active = value;

    if (active) {
      lastScrollY = window.scrollY;
      appliedTop = null;
      invalidate();
    } else {
      appliedTop = null;
      if (resolveWrapper()) wrapper.style.top = '';
    }
  }

  function init() {
    container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    lastScrollY = window.scrollY;

    var mediaQuery = window.matchMedia(BREAKPOINT);
    setActive(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', function (event) {
        setActive(event.matches);
      });
    }

    /* On observe le container (persistant) et non le wrapper : l'observateur survit ainsi à
       tous les re-rendus de filtres. Aucune boucle possible, `top` ne change aucune taille. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(invalidate).observe(container);
    }

    /* Les classes d'état du header (header-pinned, is-hide-nav…) modifient l'offset haut :
       il suffit de relire --cm-facets-top au prochain passage. */
    new MutationObserver(invalidate).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', invalidate, { passive: true });
    document.addEventListener('collection:rerendered', invalidate);

    invalidate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
